import { useInfiniteQuery } from "react-query";
import { developAxios } from "../../../axios.config";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

type TUserResponse = {
	_id: string;
	student: string;
	email: string;
	firstName: string;
	lastName: string;
};

const useGetUsers = () => {
	const location = useLocation();
	const [query, setQuery] = useState<string>("");

	useEffect(() => {
		let urlParams = new URLSearchParams(location.search);
		let query = urlParams.get("query") || "";

		let queryTimeout = setTimeout(() => {
			setQuery(query);
		}, 1000);

		return () => {
			clearTimeout(queryTimeout);
		};
	}, [location.search]);

	function fetchUsers({ pageParam = 0 }) {
		return developAxios(localStorage.getItem("token") || "").get<{
			users: TUserResponse[];
		}>(`/admin/user/search-user?query=${query}&page=${pageParam}&limit=10`);
	}

	const data = useInfiniteQuery(
		["get-users", localStorage.getItem("token"), query],
		fetchUsers
	);

	return data;
};

export default useGetUsers;
